import { Plus } from "lucide-react";
import { useState } from "react";

import { countrySelectorValues, sexSelectorValues, sizeSelectorValues } from "../services/data";
import { getFiltersIcon } from "../services/icons";
import { FilterValueUpdateType, SearchParamsType } from "../types";
import Dropdown from "./Dropdown";
import FilterCheckboxGroup from "./FilterCheckboxGroup";
import SideBar from "./SideBar";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/AccordionFilter";

type PropsType = {
  searchParams: SearchParamsType;
  onFilterValueUpdate: FilterValueUpdateType;
};

export default function PetFilter({ searchParams, onFilterValueUpdate }: PropsType) {
  const [showSidebar, setShowSidebar] = useState(false);

  const onShowSidebar = () => {
    setShowSidebar(true);
  };

  const onHideSidebar = () => {
    setShowSidebar(false);
  };

  const renderFiltersDemo = () => {
    return (
      <>
        <Dropdown
          label="Sex"
          name="gender"
          defaultValue=""
          value={searchParams["gender"]}
          values={sexSelectorValues}
          onUpdate={onFilterValueUpdate}
        />
        <Dropdown
          label="Size"
          name="size"
          defaultValue=""
          value={searchParams["size"]}
          values={sizeSelectorValues}
          onUpdate={onFilterValueUpdate}
        />
        <Dropdown
          label="Country"
          name="country"
          defaultValue=""
          value={searchParams["country"]}
          values={countrySelectorValues}
          onUpdate={onFilterValueUpdate}
        />
      </>
    );
  };

  const accordionDefaultValue = () =>
    ["gender", "size"].reduce((acc, val) => {
      return searchParams[val]?.length > 0 ? [...acc, val] : acc;
    }, []);

  const renderSelectedFiters = () => {
    const out = [];
    if (searchParams.gender || searchParams.gender?.length > 0) {
      const elemsGender = searchParams.gender?.split(",").reduce((acc, v) => {
        const val = v.trim();
        const title = sexSelectorValues.find((e) => e.value === val).title;
        return [
          ...acc,
          <div
            key={title}
            className="flex cursor-pointer items-center gap-0.5 rounded-full bg-theme-grey-1 px-4 py-2 text-[14px] font-semibold"
            onClick={() => {
              const values = searchParams.gender?.split(",");
              const excludedValue = values?.reduce((acc, v) => {
                if (v === val) {
                  return acc;
                }
                return [...acc, v];
              }, []);
              onFilterValueUpdate("gender", excludedValue.join(","));
            }}
          >
            {title}
            <div className="[&>svg]:rotate-45">
              <Plus className="h-[20px] w-[20px]" />
            </div>
          </div>,
        ];
      }, []);
      out.push(elemsGender);
    }
    return out;
  };

  console.log("searchParams", searchParams);

  return (
    <>
      <SideBar
        title="Filter"
        show={showSidebar}
        onClose={onHideSidebar}
        width="40%"
        barHeight="screen"
        // footer={<div>Filters footer</div>}
      >
        <div className="p-7">
          <Accordion type="multiple" className="w-full" defaultValue={accordionDefaultValue()}>
            <AccordionItem value="gender">
              <AccordionTrigger>
                Sex
                {searchParams["gender"]?.length > 0
                  ? ` (${searchParams["gender"]?.split(",").length})`
                  : ""}
              </AccordionTrigger>
              <AccordionContent>
                <FilterCheckboxGroup
                  name="gender"
                  value={searchParams["gender"]}
                  values={sexSelectorValues}
                  onChange={onFilterValueUpdate}
                />
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="size">
              <AccordionTrigger>
                Size
                {searchParams["size"]?.length > 0
                  ? ` (${searchParams["size"]?.split(",").length})`
                  : ""}
              </AccordionTrigger>
              <AccordionContent>
                <FilterCheckboxGroup
                  name="size"
                  value={searchParams["size"]}
                  values={sizeSelectorValues}
                  onChange={onFilterValueUpdate}
                />
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </SideBar>
      <div className="flex flex-col gap-3">
        <div className="flex w-full flex-row">
          <div className="flex flex-row items-center gap-3">
            <div
              className="flex cursor-pointer items-center gap-1 rounded-[4px] border-[1px] border-theme-grey-10.5 px-4 py-2 font-simianregular"
              onClick={onShowSidebar}
            >
              {getFiltersIcon()} <span className="font-medium leading-none">Filter dogs</span>
            </div>
            <div className="flex gap-2">{renderSelectedFiters()}</div>
          </div>
        </div>
        <div className="relative z-10">
          <span className="text-[14px] text-theme-grey-7">Sort by</span>
          <Dropdown
            label=""
            defaultValue="Default"
            values={[{ title: "Default", value: "Default" }]}
            border={false}
            name="order"
            onUpdate={onFilterValueUpdate}
          />
        </div>
      </div>
    </>
  );
}
